import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';

import { AppFeatures, isFeatureEnabled } from '@/app/features/use-feature';
import { NotFoundComponent } from '@/app/routes/__root';

export const Route = createFileRoute('/apply')({
  loader: () => {
    if (!isFeatureEnabled(AppFeatures.Applications)) throw notFound();
  },
  notFoundComponent: NotFoundComponent,
  component: Outlet
});
